import React, { Children, useState } from 'react'

const holdDistance = 3**2 // pixels squared

type Prop = {
    onClick? : (e : React.PointerEvent)=>void,
    onHold : (e : React.PointerEvent)=>void,
    className? : string,
    holdTime? : number,
    children : JSX.Element,
}

const Holdable = ({
    onClick,
    onHold, 
    holdTime = 500,
    className = '',
    children,
}:Prop) => {

  const [timer, setTimer] = useState<number | null>(null)
  const [pos, setPos] = useState([0,0])

  function onPointerDown(evt : React.PointerEvent) {
    setPos([evt.clientX, evt.clientY]) // save position for later
    const event = { ...evt } // convert synthetic event to real object
    const timeoutId = window.setTimeout(timesup.bind(null, event), holdTime)
    setTimer(timeoutId)
  }

  function onPointerUp(evt:React.PointerEvent) {
    if (timer) {
      window.clearTimeout(timer)
      setTimer(null)
      if(onClick)
        onClick(evt)
    }
  }

  function onPointerMove(evt:React.PointerEvent) {
    // cancel hold operation if moved too much
    if (timer) {
      const d = (evt.clientX - pos[0])**2 + (evt.clientY - pos[1])**2
      if (d > holdDistance) {
        setTimer(null)  
        window.clearTimeout(timer)
      }
    }
  }

  function timesup(evt:React.PointerEvent) {
    setTimer(null)
    onHold(evt)
  }

  return (
    <>
      {React.cloneElement(children, {
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        onPointerMove: onPointerMove,
        className: className,
      })}
    </>
  )
}

export default Holdable;